import Vue from 'vue'
import lazylaod from './lazyload'
import {lazyConfig as config} from './config'
import { imgDirective } from './decentImg'

lazylaod()
Vue.use(imgDirective, {
    errorImg: config.error || config.loading //设置后会捕捉error
})
